import {
  RouteDispatchTypes,
  ROUTE_LOADING,
  ROUTE_FAILURE,
  ROUTE_SUCCESS,
  VehicleRoute,
} from "../actions/routeActionTypes";
import { VehicleData } from "../actions/vehicleActionTypes";
import { loadFleetSnapshot } from "../../components/routes/map/utils/fleetSnapshot";

interface DefaultStateInterface {
  loading: boolean;
  routes?: Array<VehicleRoute>;
  timestamp?: string;
  hasData?: boolean;
  // These routes are the last fleet we saw, not an answer from the API.
  fromSnapshot?: boolean;
}

// The last fleet the API answered with, if it is recent enough to still be
// worth showing. /routes takes 20-30s, so without this every visit starts on
// an empty map.
const snapshot = loadFleetSnapshot(Date.now());

const defaultState: DefaultStateInterface = {
  loading: true,
  routes: snapshot?.routes,
  fromSnapshot: !!snapshot,
  hasData: false,
};

const routeReducer = (
  state: DefaultStateInterface = defaultState,
  action: RouteDispatchTypes
): DefaultStateInterface => {
  switch (action.type) {
    // Neither of these has anything better to show than what is already on the
    // screen. Dropping `routes` here is what emptied the map for the 20-30s the
    // API takes, once every 15s poll.
    case ROUTE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ROUTE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case ROUTE_SUCCESS:
      return {
        ...state,
        loading: false,
        routes: action.payload,
        fromSnapshot: false,
        hasData: true,
      };
    default:
      return state;
  }
};

export default routeReducer;
